import { render, staticRenderFns } from "./PieceJointe.vue?vue&type=template&id=6810fc63&scoped=true&"
import script from "./PieceJointe.vue?vue&type=script&lang=js&"
export * from "./PieceJointe.vue?vue&type=script&lang=js&"
import style0 from "./PieceJointe.vue?vue&type=style&index=0&id=6810fc63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810fc63",
  null
  
)

export default component.exports